var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6672 4.667L8.67272 8.48462C8.4693 8.60275 8.23824 8.66497 8.003 8.66497C7.76776 8.66497 7.5367 8.60275 7.33328 8.48462L1.3328 4.667M2.66624 2.6672H13.3338C14.0702 2.6672 14.6672 3.26409 14.6672 4.0004V11.9996C14.6672 12.7359 14.0702 13.3328 13.3338 13.3328H2.66624C1.9298 13.3328 1.3328 12.7359 1.3328 11.9996V4.0004C1.3328 3.26409 1.9298 2.6672 2.66624 2.6672Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMail);
export default __webpack_public_path__ + "static/media/footer-mail.c2472b1b3c99670431dbd6a964cbf92e.svg";
export { ForwardRef as ReactComponent };